import { useEffect } from 'react';

export default function SEO({ title, description, keywords, canonical, schema }) {
  useEffect(() => {
    // 1. Update Title
    if (title) {
      document.title = title;
    }

    // 2. Update Meta Description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description || '');
    } else if (description) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      metaDescription.setAttribute('content', description);
      document.head.appendChild(metaDescription);
    }

    // 3. Update Meta Keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', keywords || '');
    } else if (keywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      metaKeywords.setAttribute('content', keywords);
      document.head.appendChild(metaKeywords);
    }

    // 4. Update Canonical URL
    let linkCanonical = document.querySelector('link[rel="canonical"]');
    if (linkCanonical) {
      linkCanonical.setAttribute('href', canonical || window.location.href);
    } else {
      linkCanonical = document.createElement('link');
      linkCanonical.setAttribute('rel', 'canonical');
      linkCanonical.setAttribute('href', canonical || window.location.href);
      document.head.appendChild(linkCanonical);
    }

    // 5. Inject Structured Schema Markup (JSON-LD)
    let scriptSchema = document.querySelector('script[id="json-ld-schema"]');
    if (scriptSchema) {
      scriptSchema.textContent = JSON.stringify(schema || {});
    } else if (schema) {
      scriptSchema = document.createElement('script');
      scriptSchema.setAttribute('type', 'application/ld+json');
      scriptSchema.setAttribute('id', 'json-ld-schema');
      scriptSchema.textContent = JSON.stringify(schema);
      document.head.appendChild(scriptSchema);
    }

    // Cleanup script on unmount
    return () => {
      const existingScript = document.querySelector('script[id="json-ld-schema"]');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, [title, description, keywords, canonical, schema]);

  return null;
}
